import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { SessionService, HttpService, MessageService, FunctionsService, fileInputParams, LocalStorageService } from 'brainloper-ui';
import { Router } from '@angular/router';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { User } from 'src/app/models/administration/user';
import { SizePicture } from 'src/app/models/commos/size-pircture';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';


@Component({
    selector: 'app-modal-profile',
    templateUrl: './modal-profile.component.html',
    styleUrls: ['./modal-profile.component.scss'],
    standalone: false
})
export class ModalProfileComponent implements OnInit {

  public formProfile: UntypedFormGroup
  public formPassword: UntypedFormGroup
  public formPhoto: UntypedFormGroup
  private dataUser: Array<User>
  private userId: number
 private userPicture: string
  public companyId:number


  public hide:boolean = true
  public hideOld:boolean = true
  public hideNew:boolean = true


  public sizePicture: SizePicture
  public size: number

  public movil:boolean = screen.width > 600 ? false : true;

  private new
  public confirm
  public ok: boolean

  private fotoPH
  public imageSrc
  public file: File

  //Foto
  public fileInput: fileInputParams = {
    typeFile: "imagen",
    input: "formulario",
    label: "foto",
    edit: true,
    style: {
      width: '100%'
    }
  }


  constructor(
    public dialogRef: MatDialogRef<ModalProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: UntypedFormBuilder,
    private session: SessionService,
    private http: HttpService,
    private message: MessageService,
    private router :Router,
    private functions : FunctionsService,
    private storage : LocalStorageService

  ) {
    this.companyId = this.storage.get<number>('companyId')
    this.formProfile = this.formBuilder.group({
      name: '',
      address: '',
      phone: 0,
      email: '',
      emergencyContact: '',
      emergencyContactPhone: 0,
      dateJoining:'',
    });

    this.formPassword = this.formBuilder.group({

      password: '',
      passwordPrevious: '',
      confirmPassword:'',

    });

    this. formPhoto = this.formBuilder.group({

      photo: '',

    });
  }



  ngOnInit(): void {

    this.message.openLoading('Cargando', 'Cargando')

    this.userId = this.storage.get<number>('userId')

    this.http.getData(`${EndpointDictionary.User.CRUD_USER_DATA}/${this.userId}`).subscribe(
      (res: BaseResponse<Array<User>>) => {
        if (res['code'] === 0) {
          this.dataUser = res['body']
         // console.log(this.dataUser)
          this.userPicture = `${EndpointDictionary.Base._BASE_URL_V2}${this.dataUser[0].photo}/${this.companyId}`
          this.imageSrc=`${EndpointDictionary.Base._BASE_URL_V2}${this.dataUser[0].photo}/${this.companyId}`
          this.startFields()
          this.dataUser[0].dateJoining =  this.functions.dateIso(this.dataUser[0].dateJoining)

        } else {
          console.log('Error cargando datos usuario')
        }
      },
      err => {
        console.log(err)
      }
    )
  }

  startFields() {
    this.fotoPH = this.dataUser[0].photo
    if(this.data=='perfil'){

    for (let data of Object.keys(this.formProfile.controls)) {
      if(this.dataUser[0][data]){
      if(data == 'dateJoining'){
        this.formProfile.get(data).setValue(this.dataUser[0][data])
      }else{
        this.formProfile.get(data).setValue(this.dataUser[0][data].toString())
      }
    }
    }
    //console.log(this.formProfile)

    }

    this.size= ((screen.height+screen.width)/2)*0.22
    this.sizePicture = {
      'width': `${this.size}px`,
      'border-radius': '50%',
      'height': `${this.size}px`,
      'margin': '3px',
      'border': '1px solid black'
    }
    this.message.closeLoading()
  }

  async save(form: User) {
    this.message.openLoading('Cargando', 'Actualizando Información')

    switch (this.data) {

      case 'perfil':

      let bodyPerfil:User = this.dataUser[0]

      form.dateJoining = this.functions.dateForm(form.dateJoining)
      form.userId = bodyPerfil.userId
      //console.log(bodyPerfil)

        let res = await this.http.putDataBody(`${EndpointDictionary.User.CRUD_USER_DATA}/`, form)
        if (res) {
          this.message.closeLoading()
          this.storage.set<string>('userName', form.name)
          this.message.SuccessToast('Datos actualizados correctamente')
        } else {
          this.message.closeLoading()
        }

        this.dialogRef.close()
        break;

      case 'contrasena':

      let body = {
        "userId":this.userId,
        "newPassword":form.confirmPassword,
        "passwordPrevious":form.passwordPrevious
      }

      if(form.password==form.confirmPassword){

        let res = await this.http.postDataBody(`${EndpointDictionary.User.USER_PASSWORD}`, body)
        if (res) {
          this.message.closeLoading()
          this.message.SuccessToast('Contraseña actualizada correctamente')
          sessionStorage.clear()
          this.router.navigate(['/'])

        } else {
          this.message.closeLoading()
        }
      } else {
        this.message.closeLoading()
        this.message.Error('Error', 'la contraseña no coincide')
      }

      this.dialogRef.close()

        break;

      case 'foto':
      let bodyPhoto = this.dataUser[0]
      form.userId = bodyPhoto.userId
      let formFoto: FormData = this.crearFormularioMultipart(this.file, this.fotoPH)
      form.photo = await this.saveFile(`${EndpointDictionary.Docs.DOCS_SUBIR}`,formFoto) as string

      //console.log(bodyPhoto)

        let response = await this.http.putDataBody(`${EndpointDictionary.User.CRUD_USER_DATA}`, form)
        if (response) {
          this.message.closeLoading()
          this.message.SuccessToast('Foto actualizada correctamente')
          // setTimeout(() => {
          //   this.router.navigate(['inicio']);
          // }, 1000);
        } else {
          this.message.closeLoading()
          this.message.Error('Error!', `Código: ${response['code']} - Mensaje : ${response['sqlMessage']}`)
        }
        this.dialogRef.close()

      break;
    }


  }

  errorMessage() {
    this.message.ErrorToast('complete los campos')

  }

  change($event, data){

    if(data == 'nueva'){
      this.new = $event
    }else{
      this.confirm = $event
    }
    if(this.new == this.confirm){
      this.ok=true
    }else{
      this.ok=false
    }

  }

  fileChange($event){
    ////console.log($event)

    if($event.compressor){
      this.file = $event.compressor
    }else{
      this.file = $event.new
    }
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(this.file);
     // console.log(this.file)
  }

  crearFormularioMultipart(file:File, old){

//console.log(old)
  //  console.log(file)

    const formD = new FormData();
    formD.append('file',file,'form-data');//Asigna el campo File
    if(old){
      formD.append('old',old);//Asigna el campo File
    }
    return(formD)

  }

  saveFile(url,form){
    return new Promise((resolve,reject)=>{
      this.http.postData(url, form).subscribe(
        (res: BaseResponse<GenericResponse>) =>{
        //  //console.log(res)
          if(res['code']===0){
            this.message.closeLoading()
            resolve(res['body'])
          }else{
            this.message.closeLoading()
            reject(`Codigo: ${res['code']} - Mensaje : ${res['body']['sqlMessage']}`)
          }
        },
        err => {
          this.message.closeLoading()
          reject(err.message)
        }
      )
    })
  }



}
